import { mountSingleRace } from './utils/mount-single-race.js';
mountSingleRace('CA-84499').catch(console.error);
